module.exports = __webpack_public_path__ + "static/media/mountainsfull.6b4ca609.svg";